/**
 * 历史搜索 and 展示搜索组合 面板
 *
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2019/3/29      2.0     Second version   历史搜索记录 子组件  PeiLing
 * 2023/07/20       3.0   历史搜索 and 展示搜索组合 面板 FJJ
 *
 * Copyright 2019, all rights reserved. Essa.cn
 * */
import React from "react";
import Lang from "@components/Lang/Lang";
import "./index.less"

export default class SearchHistoryPanel extends React.Component {
    static defaultProps = {
        localList: [],
        serverList: [],
        isShow: false,
        wrapperCls: '',
        showSearchResult:false, //展示搜索结果
        buyerList: [],
        containerList:  [],
        poList:  [],
        // onClickFun: ()=>{},
    }
    constructor(props) {
        super(props);
        this.state = {
            isShow: props.isShow,
        }
    }
    handleIcon(key) {
        if (key == 'history') {
            const fn = this.props.toClearHistory
            fn && fn()
        }
    }
    // goPage(e,sUrl){
    //     e.preventDefault()
    //     console.log("this.props",this.props)
    //     this.props.history.push(sUrl);
    // }
    render() {
        const {localList,wrapperCls,onClickFun,showSearchResult,buyerList,containerList,poList } = this.props;
        const list = [
            {name:'ZuiJin', text:"最近",icon: 'icon-shanchu-01', list: localList, key: 'history', gioType:'history_word'},
        ]
        return (
            <div className="header-search-panel">
                {showSearchResult?<>
                    {/*服务端请求回来的搜索词*/}
                    <div className={"resultWrap"}>
                        <div className={"fw_700 black89 mb_8"}><span className={"ri-user-line color-danger"} /> {Lang({id:"KeHu", default:"客户"})}</div>
                        {buyerList.length>0?<>
                            {buyerList.map((buyer,inx)=><a className={"result black45"} href={`/customer/detail?id=${buyer.buyerId}`} key={"buy_"+inx}>
                                <p className={"black89"}>{buyer.buyerCode}</p>
                                <p>{buyer.buyerName}</p>
                            </a>)}
                            {/*{buyerList.map((buyer,inx)=><div className={"result black45"} onClick={(e)=>this.goPage(e,`/customer/detail?id=${buyer.buyerId}`)} key={"buy_"+inx}>*/}
                                {/*<p className={"black89"}>{buyer.buyerCode}</p>*/}
                                {/*<p>{buyer.buyerName}</p>*/}
                            {/*</div>)}*/}
                        </>:<div className={"black45 font_14 fw_400"}>
                            {Lang({id:"MeiZhaoDaoJieGuo",default:"没找到结果"})}
                            </div>}
                    </div>
                    <div className={"resultWrap"}>
                        <div className={"fw_700 black89 mb_8"}><span className={"ri-file-list-2-line color-blue"} /> {Lang({id:"DingDan", default:"订单"})}</div>
                        {poList.length>0?<>
                            {poList.map((po,inx)=><a className={"result black45"} href={`/order/sale/detail?id=${po.poId}`} key={"po_"+inx}>
                                <p className={"black89"}>{po.poCode}</p>
                            </a>)}
                        </>:<div className={"black45 font_14 fw_400"}>
                            {Lang({id:"MeiZhaoDaoJieGuo",default:"没找到结果"})}
                        </div>}
                    </div>
                    <div className={"resultWrap"}>
                        <div className={"fw_700 black89 mb_8"}><span className={"ri-archive-drawer-line color-green"} /> {Lang({id:"JiGui", default:"集柜"})}</div>
                        {containerList.length>0?<>
                            {containerList.map((container,inx)=><a className={"result black45"}
                                                                    //type = 2 已出货 默认为1预出货
                                                                   href={`/shipperManagement/${container.type==2?"shippingOrder":"estimatedShippingOrder"}/detail?${container.containerId}`}
                                                                   key={"container_"+inx}>
                                <p className={"black89"}>{container.containerCode}</p>
                            </a>)}
                        </>:<div className={"black45 font_14 fw_400"}>
                            {Lang({id:"MeiZhaoDaoJieGuo",default:"没找到结果"})}
                        </div>}

                    </div>
                </>:<>
                    {/*历史搜索记录 */}
                    {
                        list.map((item, index) => (
                            item.list.length>0&&<div className="" key={index.toString()}>
                                <div className="flex-item-between mb_8">
                                    <span className="font-14 fw_700 black89">{Lang({id:item.name,default:item.text,})}</span>
                                    <span onClick={this.handleIcon.bind(this, item.key)}
                                        className={['ri-delete-bin-line cursor-p', item.icon].join(' ')}></span>
                                </div>
                                <ul className={`s-item${wrapperCls?" "+wrapperCls:""}`}>
                                    {
                                        item.list.map(function (outItem, outIndex) {
                                            const words = typeof outItem === 'object' ? (outItem.words || outItem.name) : outItem;
                                            const hoverCls = '';
                                            return (
                                                <li className={`s-li cursor-p ${hoverCls}`}
                                                    key={outIndex}
                                                    title={words}
                                                    onClick={() => {
                                                       if(onClickFun)onClickFun(words)
                                                    }}>
                                                    {outItem.show?<span className="iconfont icon-search-hot margin-right-5 util-v-m font-12"></span>:null}
                                                    <span className="util-v-m">{words}</span>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        ))
                    }
                </>}
            </div>
        )
    }
}
